import create from "zustand";

const useNotificationStore = create((set) => ({
  totalPendingCount: 0,
  adminNotifications: [],
  adminawsNotifications: [],
  adminazureNotifications: [],
  admingcpNotifications: [],
  adminweburlNotifications: [],
  adminK8Notifications: [],

  adminApprovedNotifications: [],
  adminAWSApprovedNotifications: [],
  adminAzureApprovedNotifications: [],
  adminGCPApprovedNotifications: [],
  adminK8ApprovedNotifications: [],
  adminWebUrlApprovedNotifications: [],

  adminPremPageNo: 1,
  adminAWSPageNo: 1,
  adminAzurePageNo: 1,
  adminK8PageNo: 1,
  adminGCPPageNo: 1,
  adminWebPageNo: 1,
  userPremPageNo: 1,
  userAWSPageNo: 1,
  userAzurePageNo: 1,
  userK8PageNo: 1,
  userGCPPageNo: 1,
  userWebPageNo: 1,


  adminPremParams: {},
  adminAWSParams: {},
  adminAzureParams: {},
  adminK8Params: {},
  adminGCPParams: {},
  adminWebParams: {},

  awsConfig: null,
  azureConfig: null,
  gcpConfig: null,
  awsUserConfig: null,
  azureUserConfig: null,
  gcpUserConfig: null,

  setCloudConfigs: (configs) => set(() => ({ ...configs })),

  setTotalPendingCount: (count) => {
    set(() => ({
      totalPendingCount: count,
    }));
  },

  setApprovedNotifications: (notifications) => {
    set(() => ({
      adminApprovedNotifications: notifications,
    }));
  },

  setAdminNotifications: (notifications) => {
    set(() => ({
      adminNotifications: notifications,
    }));
  },

  setAdminAWSNotifications: (notifications) => {
    set(() => ({
      adminawsNotifications: notifications,
    }));
  },
  setAdminAzureNotifications: (notifications) => {
    set(() => ({
      adminazureNotifications: notifications,
    }));
  },
  setAdminGcpNotifications: (notifications) => {
    set(() => ({
      admingcpNotifications: notifications,
    }));
  },

  setAdminWebUrlNotifications: (notifications) => {
    set(() => ({
      adminweburlNotifications: notifications,
    }));
  },
  setAdminK8Notifications: (notifications) => {
    set(() => ({
      adminK8Notifications: notifications,
    }));
  },

  setAdminAWSApprovedNotifications: (notifications) => {
    set(() => ({ adminAWSApprovedNotifications: notifications }));
  },
  setAdminAzureApprovedNotifications: (notifications) => {
    set(() => ({ adminAzureApprovedNotifications: notifications }));
  },
  setAdminGCPApprovedNotifications: (notifications) => {
    set(() => ({ adminGCPApprovedNotifications: notifications }));
  },
  setAdminK8ApprovedNotifications: (notifications) => {
    set(() => ({ adminK8ApprovedNotifications: notifications }));
  },
  setAdminWebUrlApprovedNotifications: (notifications) => {
    set(() => ({ adminWebUrlApprovedNotifications: notifications }));
  },

  userNotifications: [],
  setUserNotifications: (notifications) => {
    set(() => ({
      userNotifications: notifications,
    }));
  },
  userAWSNotifications: [],
  setUserAWSNotifications: (notifications) => {
    set(() => ({
      userAWSNotifications: notifications,
    }));
  },
  userAzureNotifications: [],
  setUserAzureNotifications: (notifications) => {
    set(() => ({
      userAzureNotifications: notifications,
    }));
  },
  userGcpNotifications: [],
  setUserGcpNotifications: (notifications) => {
    set(() => ({
      userGcpNotifications: notifications,
    }));
  },
  userWebUrlNotifications: [],
  setUserWebUrlNotifications: (notifications) => {
    set(() => ({
      userWebUrlNotifications: notifications,
    }));
  },
  userK8Notifications: [],
  setUserK8Notifications: (notifications) => {
    set(() => ({
      userK8Notifications: notifications,
    }));
  },
  userApprovedNotifications: [],
  userAWSApprovedNotifications: [],
  userAzureApprovedNotifications: [],
  userGCPApprovedNotifications: [],
  userK8ApprovedNotifications: [],
  userWebUrlApprovedNotifications: [],

  setUserApprovedNotifications: (notifications) =>
    set(() => ({ userApprovedNotifications: notifications })),
  setUserAWSApprovedNotifications: (notifications) =>
    set(() => ({ userAWSApprovedNotifications: notifications })),
  setUserAzureApprovedNotifications: (notifications) =>
    set(() => ({ userAzureApprovedNotifications: notifications })),
  setUserGCPApprovedNotifications: (notifications) =>
    set(() => ({ userGCPApprovedNotifications: notifications })),
  setUserK8ApprovedNotifications: (notifications) =>
    set(() => ({ userK8ApprovedNotifications: notifications })),
  setUserWebUrlApprovedNotifications: (notifications) =>
    set(() => ({ userWebUrlApprovedNotifications: notifications })),

  setAdminPremPageNo: (page) => {
    set(() => ({ adminPremPageNo: page }));
  },
  setAdminAWSpageNo: (page) => set(() => ({ adminAWSPageNo: page })),
  setAdminAzurepageNo: (page) => set(() => ({ adminAzurePageNo: page })),
  setAdminK8pageNo: (page) => set(() => ({ adminK8PageNo: page })),
  setAdminGCPpageNo: (page) => set(() => ({ adminGCPPageNo: page })),
  setAdminWebpageNo: (page) => set(() => ({ adminWebPageNo: page })),
  setUserPremPageNo: (page) => set(() => ({ userPremPageNo: page })),
  setUserAWSpageNo: (page) => set(() => ({ userAWSPageNo: page })),
  setUserAzurepageNo: (page) => set(() => ({ userAzurePageNo: page })),
  setUserK8pageNo: (page) => set(() => ({ userK8PageNo: page })),
  setUserGCPpageNo: (page) => set(() => ({ userGCPPageNo: page })),
  setUserWebpageNo: (page) => set(() => ({ userWebPageNo: page })),



  setAdminPremParams: (page) => {
    set(() => ({ adminPremParams: page }));
  },
  setAdminAWSParams: (page) => set(() => ({ adminAWSParams: page })),
  setAdminAzureParams: (page) => set(() => ({ adminAzureParams: page })),
  setAdminK8Params: (page) => set(() => ({ adminK8Params: page })),
  setAdminGCPParams: (page) => set(() => ({ adminGCPParams: page })),
  setAdminWebParams: (page) => set(() => ({ adminWebParams: page })),

}));

export default useNotificationStore;
